import { createWebHistory, createRouter } from "vue-router";
import { RouteRecordRaw } from "vue-router";
import Language from "@/components/language/index.vue";
import Photo from "@/components/photos/index.vue";
import { i18n, defaultLocale } from "./i18n";

export enum Routes {
  Photo = 'Photo',
  Document = 'Document'
}

const routes: Array<RouteRecordRaw> = [
  {
    path: '/:lang',
    component: Language,
    beforeEnter: (to, _, next) => {
      if (!i18n.global.availableLocales.includes(to.params.lang as string)) {
        return next({ ...to, params: { ...to.params, lang: defaultLocale } })
      }

      return next()
    },
    props: true,
    children: [
      {
        path: ':sessionType/:uuid',
        component: Photo,
        props: true,
        name: Routes.Photo
      }
    ]
  },
  {
    path: '/:lang/:uuid',
    redirect(to) {
      return { name: Routes.Photo, params: {...to.params, sessionType: 'photo'} }
    },
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;